import { ErrorDeCable } from "./api";

/**
 * De un fallo del cable al renglón que lee una persona.
 *
 * Vive APARTE de la pantalla porque cada línea de aquí es una decisión que se
 * puede perder sin que nada se rompa, y porque así se puede probar sin montar
 * React (esta casa prueba lógica, no renderizados).
 *
 * LAS DOS QUE IMPORTAN:
 *
 *  401 — no distingue «no existe» de «contraseña equivocada». La API se cuidó
 *        de responder idéntico a los dos casos (anti-enumeración, con un hash
 *        señuelo para que ni el TIEMPO los distinga). Si el cliente inventara
 *        aquí la diferencia, desharía esa decisión desde fuera.
 *
 *  403 — es el middleware de CSRF, que exige `Origin` a toda petición con
 *        cookie. Dicho como «no tienes permiso» manda a revisar capacidades y
 *        roles durante una hora; el problema es un encabezado. Le pasó a las
 *        pruebas del cable antes que a ninguna persona.
 */
export function mensajeDeError(e: unknown): string {
  if (e instanceof ErrorDeCable) {
    if (e.estado === 401) return "Usuario o contraseña incorrectos.";
    if (e.estado === 403) {
      return "El navegador no mandó el origen esperado. Recarga la página.";
    }
    if (e.estado === 409) return "Ya hay una cuenta con ese usuario.";
    if (e.estado === 404) return "Eso ya no existe. Recarga la página.";
    if (e.estado >= 500) return "El servidor falló. Inténtalo otra vez.";
    // Lo que la API explique, se muestra: sus mensajes de validación están
    // escritos para leerse (los del generador dicen qué campo sobra).
    if (typeof e.detalle === "string" && e.detalle.trim()) return e.detalle;
    return "La petición no se pudo completar.";
  }
  // Un fallo de red no trae estado. No se disfraza de error del servidor.
  return "No se pudo conectar. Inténtalo otra vez.";
}
